/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'example2',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example2'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'dashboards.project',
                title: 'Project',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/dashboards/project',
            },
            {
                id: 'dashboards.finance',
                title: 'Finance',
                type: 'basic',
                icon: 'heroicons_outline:banknotes',
                link: '/dashboards/finance',
            }
        ],
    },
    {
        id: 'report',
        title: 'Reporte',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id   : 'report.trx',
                title: 'Reporte',
                type : 'basic',
                icon : 'heroicons_outline:queue-list',
                link : '/report/trx'
            }
        ],
    },
    {
        id   : 'balance',
        title: 'Finanzas',
        type : 'basic',
        icon : 'heroicons_outline:banknotes',
        link : '/report/balance'
    }
];

